import { createApp } from 'vue';
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

import { createPinia } from 'pinia';
import router from './router';

import App from '@/App.vue';
import { i18n } from '@/i18n';

import '@/preloader';
import '@/styles/global.scss';

const pinia = createPinia();
const app = createApp(App);


if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    app,
    dsn: 'https://0ae6e90c6ab54a6abd8b59fb01ca64f6@sentry.twrevenue.garenanow.com/199',
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "anni5saryinfo.web.test.freefiremobile.com", /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
  });
}
app.use(router);
app.use(i18n).use(pinia).mount('#app');
